import type { StorageNode } from '@d/sdk'

export type ToolbarAction = ToolbarEntry | ToolbarDivider

export interface ToolbarEntry {
  icon: string
  action: () => void
  tooltip: string
  condition?: boolean
  color?: string
  loading?: boolean
  disabled?: boolean
  iconOnly?: boolean
  position: 'left' | 'right'
  shortcut?: string
  shortcutDisplayOnly?: boolean
}

export interface ToolbarDivider {
  divider: true
  condition?: boolean
  position: 'left' | 'right'
}

export enum FileAction {
  COPY = 'copy',
  MOVE = 'move',
  RENAME = 'rename',
  CREATE = 'create',
  DELETE = 'delete',
  CONVERT = 'convert',
  DELETEFINALLY = 'deleteFinally',
  RESTOREFILE = 'restoreFile',
  REFERENCES = 'references',
  VERSIONING = 'versioning',
  PRINT = 'print',
  SHARELINK = 'sharelink',
}

export enum ConvertAction {
  FOLDER = 'folder',
  TEMPLATE = 'template',
  MANUAL = 'manual',
}

export interface FileActionProps {
  file: StorageNode
  path: string[]
  action: FileAction
  parentSubmit: (follow?: boolean) => Promise<boolean>
  reset?: number
  locked: boolean
}
